import React, {useState, useRef} from 'react'
import Tools from '../../components/Tools/Tools'
import {useSelector} from 'react-redux';
import ManageDisbursmentHeader from '../../components/Disbursment/ManageDisbursmentHeader';
import BudgetSurrender from '../../components/BudgetSurrender/BudgetSurrender';
import SubHeader from '../../components/Subheader/Subheader';


export default function BudgetSurrenderPendingList() {
    const {authData, financialYears} = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dateColumn, setDateColumn] = useState('approval_date');
    const [searchStr, setToSearchStr] = useState('');
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));


    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setDateColumn(dateColumn);
        setToSearchStr(searchStr);
    };

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                <BudgetSurrender fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr} pending={true} title={"Budget Surrender Pending"}/>
            </div>
        </div>
    )
}